import { action, computed } from 'mobx';

import api from 'core/util/api';
import { Collection } from 'core/model/Collection';

import { RuleJson } from '@kentik/ui-shared/types/interfaceClassification';
import RuleModel from './RuleModel';

class RuleCollection extends Collection<RuleModel> {
  get url() {
    return '/api/ui/interfaces/rules';
  }

  get model() {
    return RuleModel;
  }

  @action
  updateRuleInterfaceMatchData(ruleInterfaceMatches: Record<string, Partial<RuleJson>>) {
    const keys = Object.keys(ruleInterfaceMatches);

    if (keys.length > 0) {
      keys.forEach((key) => {
        const rule = this.get(key);
        if (rule) {
          rule.set(ruleInterfaceMatches[key]);
        }
      });
    } else {
      this.each((rule) =>
        rule.set({
          interfacesClassified: [],
          interfacesMatched: []
        })
      );
    }
  }

  /**
   * Note: this assumes there is only one kentik managed rule which unfortunately may not be correct :(
   */
  @computed
  get kentikManagedRule() {
    return this.models.find((model) => model.get('kentik_managed_rule'));
  }

  @action
  getRuleMatchResults = () => api.get(`${this.url}/results`);

  // Note: this doesn't seem like it's needed. The sparse data works just fine AFAICT and this is expensive af.
  // .then((results) => {
  // const INTERFACE_BLANK_FIELDS = [
  //   'id',
  //   'snmp_id',
  //   'provider',
  //   'snmp_alias',
  //   'snmp_speed',
  //   'initial_provider',
  //   'network_boundary',
  //   'connectivity_type',
  //   'interface_description',
  //   'initial_network_boundary',
  //   'initial_connectivity_type'
  // ];
  //
  // const INTERFACE_BOOLEAN_FIELDS = ['isClassified'];
  //
  // const RULE_MATCHED_BOOLEAN_FIELDS = [
  //   'didClassify',
  //   'provider_classified',
  //   'network_boundary_classified',
  //   'connectivity_type_classified'
  // ];
  //
  // // TODO: should do some perf optimizations here
  // for (let i = 0; i < results.length; i++) {
  //   const { results: result } = results[i];
  //
  //   // Fill in missing rules
  //   for (let j = 0; j < this.models.length; j++) {
  //     const rule = this.models[j];
  //     result.rules ??= [];
  //     // if not in results, assume no match
  //     if (!result.rules.find((r) => r.id === rule.id)) {
  //       result.rules.push({
  //         id: rule.id,
  //         interfacesMatched: [],
  //         interfacesClassified: []
  //       });
  //     }
  //   }
  //
  //   // Fill in sparsely populated interfaces
  //   result.interfaces ??= [];
  //   for (let k = 0; k < result.interfaces.length; k++) {
  //     const intf = result.interfaces[k];
  //
  //     for (let l = 0; l < INTERFACE_BLANK_FIELDS.length; l++) {
  //       const field = INTERFACE_BLANK_FIELDS[l];
  //       if (intf[field] === 'undefined') {
  //         intf[field] = '';
  //       }
  //     }
  //     for (let m = 0; m < INTERFACE_BOOLEAN_FIELDS.length; m++) {
  //       const field = INTERFACE_BOOLEAN_FIELDS[m];
  //       if (intf[field] === 'undefined') {
  //         intf[field] = false;
  //       }
  //     }
  //
  //     intf.rules_matched ??= [];
  //     for (let n = 0; n < intf.rules_matched.length; n++) {
  //       const rule = intf.rules_matched[n];
  //       for (let o = 0; o < RULE_MATCHED_BOOLEAN_FIELDS.length; o++) {
  //         const field = RULE_MATCHED_BOOLEAN_FIELDS[o];
  //         if (rule[field] === 'undefined') {
  //           rule[field] = false;
  //         }
  //       }
  //     }
  //   }
  //
  //   result.matchInfo = {
  //     interfaceCount: 0,
  //     interfacesClassifiedCount: 0,
  //     rulesUsed: 0,
  //     ...result.matchInfo
  //   };
  // }
  //
  // console.timeEnd('processing rule match results');
  //
  // return results;
}

export default RuleCollection;
